import {
  FORMEDIT_FORMSUBMIT_MODAL_CHANGE,
} from './constants';

export function formSubmitModalChange(visible,type) {
  return {
    type: FORMEDIT_FORMSUBMIT_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FORMEDIT_FORMSUBMIT_MODAL_CHANGE:
      return {
        ...state,
        formSubmitModalType:action.data.type,
        formSubmitModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/formedit/redux/formSubmitModalChange.js